import Vue from "vue";
import VModal from "vue-js-modal";
import SwiperConfig from "../scripts/swiper-config";
import VueCookies from "vue-cookies";

// Import configuration and storage
import store from "./store/store.js";

// Import components
import WFProductTiles from "./components/wf-product-tiles.vue";
import WFProductDisplayControls from "./components/wf-product-display-controls.vue";
import PCPdpMenuBar from "./components/product-details-page/pc-pdp-menu-bar.vue";
import PCProductRoomSceneColors from "./components/product-details-page/pc-product-room-scene-colors.vue";
import PcDyelotsPopup from "./components/product-details-page/pc-product-dyelots-popup.vue";
import PcPdfPopup from "./components/product-search/pc-product-pdf-popup.vue";
import PCProductFeatureImageBlocks from "./components/product-details-page/pc-product-feature-image-blocks.vue";
import WFProductRoomScene from "./components/product-details-page/wf-product-room-scene.vue";
import WFProductDetailState from "./components/product-details-page/wf-product-detail-state.vue";
import WFAddToCartButton from "./components/wf-add-to-cart-button.vue";
import PcIdeaBookBanner from "./components/ideabook/pc-ideabook-banner.vue";
import WFIdeabookDownloads from "./components/wf-ideabook-downloads.vue";
import WFBackToTopButton from "./components/wf-back-to-top-button.vue";
import WFAnchorBarItem from "./components/wf-anchor-bar-item.vue";
import WFEventListing from "./components/wf-event-listing.vue";
import WFEventListingItem from "./components/wf-event-listing-item.vue";
import WFArticleListing from "./components/wf-article-listing.vue";
import WFVideoModal from "./components/wf-video-modal.vue";
import WFVideoModalButton from "./components/wf-video-modal-button.vue";
import WFNotifications from "./components/wf-notifications.vue";
import WFLandingPageTabs from "./components/wf-landing-page-tabs.vue";
import WFDownloadImageModal from "./components/wf-download-image-modal.vue";
import WFViolatorBar from "./components/wf-violator-bar.vue";
import PCGTMLogger from "./components/pc-gtm-event-logger.vue";
import ProductSearchContainer from "./components/product-search/pc-product-search-container.vue";
import ProductCompareContainer from "./components/product-search/pc-product-compare.vue";
import ProductCompareModal from "./components/product-search/pc-product-compare-modal.vue";
import ProductCompareDownload from "./components/product-search/pc-product-compare-download.vue";
import PCVIRTUALTRAYCONTAINER from "./components/virtual-tray/pc-vt-container.vue";
import PCSITESEARCH from "./components/site-search/pc-site-search-container.vue";
import SEARCHRESULTSPAGE from "./components/search-results-page/pc-search-results-page-container.vue";
import TrimsAndAccessoriesPage from "./components/trims-accessories-page/pc-trims-accessories-page.vue";
// import SalesforceOpportunities from "./components/checkout-page/pc-salesforce-opportunities.vue";
import SalesforceOpportunities from "./components/new-checkout-page/pc-salesforce-opportunities.vue"; // new sales force opportunity page
import TrimsAndAccessoriesControls from "./components/trims-accessories-page/pc-trims-accessories-controls.vue";
import TrimsAndAccessoriesResult from "./components/trims-accessories-page/pc-trims-accessories-result.vue";
import TrimsAndAccessoriesSideFilters from "./components/trims-accessories-page/pc-trims-accessories-side-filters.vue";
import PCProductSpecifications from "./components/product-details-page/pc-product-specifications.vue";
import PCProductAsideTop from "./components/product-details-page/pc-product-aside-top.vue";
import CheckoutBasketSidebar from "./components/basket-page/checkout-basket-sidebar.vue";
import CheckoutShipping from "./components/checkout-shipping.vue";
import PCProductAsideBottom from "./components/product-details-page/pc-product-aside-bottom.vue";
import PCFeaturedCollections from "./components/pc-featured-collections.vue";
import PCInspirationSectionPage from "./components/inspiration-page/pc-inspiration-section-page.vue";
import PCProductKeyFeatures from "./components/product-details-page/pc-product-key-features.vue";
import PcProductCoordinatingProducts from "./components/product-details-page/pc-product-coordinating-products.vue";
// import PcBasketPage from "./components/basket-page/pc-basket-page.vue";
import PcBasketPage from "./components/new-basket-page/pc-basket-page.vue"; // new basket
// import PCCheckoutPage from "./components/checkout-page/pc-checkout-page.vue"; 
import PCCheckoutPage from "./components/new-checkout-page/pc-checkout-page.vue"; // new checkout page
import CheckoutProject from "./components/checkout-page/checkout-project.vue";
import BenjaminMoorePage from "./components/benjamin-moore/benjamin-moore-page.vue";
import PcProductBackToResult from "./components/product-details-page/pc-product-back-to-result.vue";
// import ConfirmationCheckout from "./components/checkout-page/confirmation-checkout.vue";
import ConfirmationCheckout from "./components/new-checkout-page/pc-checkout-confirmation.vue" // new checkout confirmation
import ShippingOptions from "./components/checkout-page/shipping-options.vue";
import PcAccountPage from "./components/account-page/pc-account-page.vue";
import PcMyTrayPage from "./components/my-trays-page/pc-my-tray-page.vue";
import PcMyProjectPage from "./components/my-projects-page/pc-my-project-page.vue";
import PcEditMyProjectPage from "./components/my-projects-page/pc-my-project-edit.vue";
import PcMyOrdersPage from "./components/my-orders-page/pc-my-orders-page.vue";
import PcAccountSupportPage from "./components/account-support/pc-account-support-page.vue";
import PcBlogsLatestArticle from "./components/blogs/pc-blogs-latest-article.vue";
import PcBlogArticleContainer from "./components/blogs-article-page/pc-blog-article-container.vue";
import PcArticleDetails from "./components/blogs-article-page/pc-article-details.vue";
import PcArticlePreviousNext from "./components/blogs-article-page/pc-article-previous-next.vue";
import PcProductCollectionPage from "./components/product-collection/pc-collection-page.vue";
import PcEventPage from "./components/event-page/pc-event-page.vue";
import ImageGalleryWidget  from "./components/pc-image-gallery-widget.vue";
import PcSaveToProjectButton from "./components/common/pc-save-to-project-button.vue";
import pcInspirationSectionPageGallery from "./components/inspiration-page/pc-inspiration-section-page-gallery.vue";
import pcProductAccordion from "./components/product-details-page/pc-product-accordion.vue";
import pcProductDocumentsCarousel from "./components/product-details-page/pc-product-documents-carousel.vue";
// Add configuration settings to Vue prototype
import config from "../config.js";
Vue.prototype.$config = config;

// Add helper functions to Vue prototype
import helpers from "../helpers.js";
Vue.prototype.$helpers = helpers;

// Add gtm events to Vue prototype
import gtm from "../gtm-event-helper.js";
Vue.prototype.$gtm = gtm;

Vue.prototype.$resourceString = window.PatcraftResources;
Vue.prototype.$isDebug = process.env.VUE_APP_DEBUG != "false";

Vue.mixin({
  methods: {
    l: function(msg) {
      if (this.$isDebug) console.log(msg);
    }
  }
});

// Register Vue directives
// wf-swiper: initialize the element as a Swiper slider
// Pass custom Swiper parameters and slide change event through the binding value
Vue.directive("wf-swiper", {
  inserted: function(el, binding, vnode) {
    const swiper = SwiperConfig.initializeSwiper(el, binding.value.parameters);

    if (binding.value.slideChangeEvent) {
      swiper.on("slideChange", binding.value.slideChangeEvent);
    }
  },
  unbind: function(el, binding, vnode) {
    SwiperConfig.destroySwiper(el);
  }
});
Vue.directive("click-outside", {
  inserted: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

// Register plugins
Vue.use(VModal);

Vue.use(VueCookies);

// Initialize Vue instances
createVueInstance("#vue-wf-search-menu", {
  store: store,
  components: {
    "pc-site-search": PCSITESEARCH
  }
});


createVueInstance("#vue-save-to-project-button", {
  store: store,
  components: {
    "pc-save-to-project-button": PcSaveToProjectButton
  }
});
createVueInstance("#vue-pc-product-accordion", {
  store: store,
  components: {
    "pc-product-accordion": pcProductAccordion
  }
});



createVueInstance("#vue-pc-product-documents-carousel", {
  store: store,
  components: {
    "pc-product-documents-carousel":pcProductDocumentsCarousel
  }
});
createVueInstance("#vue-pc-inspiration-section-page-gallery", {
  store: store,
  components: {
    "pc-inspiration-section-page-gallery": pcInspirationSectionPageGallery
  }
});

createVueInstance("#vue-image-gallery-widget", {
  store: store,
  components: {
    "image-gallery-widget": ImageGalleryWidget
  }
});

createVueInstance("#vue-wf-product-category", {
  store: store,
  components: {
    "wf-product-display-controls": WFProductDisplayControls,
    "product-search-container": ProductSearchContainer,
    "product-compare-container": ProductCompareContainer,
    "product-compare-modal": ProductCompareModal,
    "product-compare-download": ProductCompareDownload
  }
});

createVueInstance("#vue-pc-trims-accessories-page", {
  store: store,
  components: {
    "pc-trims-accessories-page": TrimsAndAccessoriesPage,
    "pc-trims-accessories-controls": TrimsAndAccessoriesControls,
    "pc-trims-accessories-result": TrimsAndAccessoriesResult,
    "pc-trims-accessories-side-filters": TrimsAndAccessoriesSideFilters
  }
});

createVueInstance("#vue-pc-salesforce-opportunities", {
  store: store,
  components: {
    "pc-salesforce-opportunities": SalesforceOpportunities,
  }
});

createVueInstance("#vue-event-page", {
  store: store,
  components: {
    "pc-event-page": PcEventPage
  }
});

createVueInstance("#vue-wf-product-collection", {
  store: store,
  components: {
    "pc-product-collection-page": PcProductCollectionPage
  }
});

createVueInstance("#vue-wf-product-display-controls", {
  store: store,
  components: {
    "wf-product-display-controls": WFProductDisplayControls
  }
});

createVueInstance("#vue-pc-pdp-menu-bar", {
  store: store,
  components: {
    "pc-pdp-menu-bar": PCPdpMenuBar
  }
});

createVueInstance("#vue-wf-product-room-scene", {
  store: store,
  components: {
    "wf-product-room-scene": WFProductRoomScene
  }
});

createVueInstance("#vue-pc-product-room-scene-colors", {
  store: store,
  components: {
    "pc-product-room-scene-colors": PCProductRoomSceneColors
  }
});

createVueInstance("#vue-pc-product-dyelots-popup", {
  store: store,
  components: {
    "pc-product-dyelots-popup": PcDyelotsPopup
  }
});

createVueInstance("#vue-pc-product-pdf-popup", {
  store: store,
  components: {
    "pc-product-pdf-popup": PcPdfPopup
  }
});

createVueInstance("#vue-pc-product-feature-image-blocks", {
  store: store,
  components: {
    "pc-product-feature-image-blocks": PCProductFeatureImageBlocks
  }
});

createVueInstance(".vue-wf-featured-collection-gallery", {
  store: store,
  components: {
    "pc-featured-collections": PCFeaturedCollections
  }
});

createVueInstance(".vue-wf-product-detail-state", {
  store: store,
  components: {
    "wf-product-detail-state": WFProductDetailState,
    "pc-product-specifications": PCProductSpecifications,
    "pc-product-aside-top": PCProductAsideTop,
    "pc-product-aside-bottom": PCProductAsideBottom,
    "pc-product-coordinating-products": PcProductCoordinatingProducts,
    "pc-product-back-to-result": PcProductBackToResult,
    "pc-product-key-features": PCProductKeyFeatures,
  }
});

createVueInstance(".vue-wf-ecommerce-state", {
  store: store,
  components: {
    "wf-add-to-cart-button": WFAddToCartButton,
    "checkout-basket-sidebar": CheckoutBasketSidebar,
    "checkout-shipping": CheckoutShipping,
    "checkout-project": CheckoutProject,
    "shipping-options": ShippingOptions
  }
});

createVueInstance(".pc-checkout-confirmation", {
  store: store,
  components: {
    "pc-order-confirmation": ConfirmationCheckout
  }
});

createVueInstance("#wf-ideabook-detail", {
  store: store,
  components: {
    "pc-ideabook-banner": PcIdeaBookBanner,
    "wf-ideabook-downloads": WFIdeabookDownloads
  }
});

createVueInstance("#vue-wf-back-to-top-button", {
  store: store,
  components: {
    "wf-back-to-top-button": WFBackToTopButton
  }
});

createVueInstance("#vue-wf-anchor-bar", {
  store: store,
  components: {
    "wf-anchor-bar-item": WFAnchorBarItem
  }
});

createVueInstance("#vue-wf-search-results-page", {
  store: store,
  components: {
    "search-results-page": SEARCHRESULTSPAGE
  }
});

createVueInstance("#vue-wf-event-listing", {
  store: store,
  components: {
    "wf-event-listing": WFEventListing,
    "wf-event-listing-item": WFEventListingItem
  }
});

createVueInstance(".vue-wf-article-listing", {
  store: store,
  components: {
    "wf-article-listing": WFArticleListing
  }
});

createVueInstance("#vue-wf-blog-article-page", {
  store: store,
  components: {
    "pc-blog-article-container": PcBlogArticleContainer,
    "pc-article-details": PcArticleDetails,
    "wf-article-listing": WFArticleListing,
    "pc-article-previous-next": PcArticlePreviousNext,
  }
});

createVueInstance("#vue-wf-video-modal", {
  store: store,
  components: {
    "wf-video-modal": WFVideoModal
  }
});

createVueInstance(".vue-wf-video-modal-button", {
  store: store,
  components: {
    "wf-video-modal-button": WFVideoModalButton
  }
});

createVueInstance("#vue-wf-notifications", {
  store: store,
  components: {
    "wf-notifications": WFNotifications
  }
});

createVueInstance("#landing-page-tabs", {
  store: store,
  components: {
    "wf-landing-page-tabs": WFLandingPageTabs
  }
});

createVueInstance("#vue-wf-product-tiles", {
  store: store,
  components: {
    "wf-product-tiles": WFProductTiles
  }
});

createVueInstance("#vue-wf-download-image-modal", {
  store: store,
  components: {
    "wf-download-image-modal": WFDownloadImageModal
  }
});

createVueInstance("#vue-wf-violator-bars", {
  store: store,
  components: {
    "wf-violator-bar": WFViolatorBar
  }
});

createVueInstance(".vue-pc-gtm-event-logger", {
  store: store,
  components: {
    "pc-gtm-event-logger": PCGTMLogger
  }
});

createVueInstance("#vue-virtual-tray-container", {
  store: store,
  components: {
    "pc-virtual-tray-container": PCVIRTUALTRAYCONTAINER
  }
});

createVueInstance("#vue-pc-inspiration-section-page", {
  store: store,
  components: {
    "pc-inspiration-section-page": PCInspirationSectionPage
  }
});

createVueInstance("#vue-basket", {
  store: store,
  components: {
    "pc-basket-page": PcBasketPage
  }
});

createVueInstance("#vue-checkout", {
  store: store,
  components: {
    "pc-checkout-page": PCCheckoutPage
  }
});

createVueInstance("#vue-pc-benjamin-moore", {
  store: store,
  components: {
    "benjamin-moore-page": BenjaminMoorePage
  }
});

createVueInstance("#vue-account-page", {
  store: store,
  components: {
    "pc-account-page": PcAccountPage
  }
});

createVueInstance("#vue-my-tray-page", {
  store: store,
  components: {
    "pc-my-tray-page": PcMyTrayPage
  }
});

createVueInstance("#vue-my-project-page", {
  store: store,
  components: {
    "pc-my-project-page": PcMyProjectPage
  }
});

createVueInstance("#vue-edit-my-project-page", {
  store: store,
  components: {
    "pc-edit-my-project-page": PcEditMyProjectPage
  }
});

createVueInstance("#vue-my-orders-page", {
  store: store,
  components: {
    "pc-my-orders-page": PcMyOrdersPage
  }
});

createVueInstance("#vue-account-support-page", {
  store: store,
  components: {
    "pc-account-support-page": PcAccountSupportPage
  }
  });

createVueInstance("#vue-wf-blog-page", {
  store: store,
  components: {
    "pc-blogs-latest-article": PcBlogsLatestArticle
  }
});

// Helper functions
// Creates a Vue instance for each element matching the selector
function createVueInstance(selector, config) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    new Vue({
      ...config,
      ...{ el: element }
    });
  });
}
